import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';
import { plugins } from './plugins';

Vue.use(Vuex);

export default function({area, tenant, config}, router) {
    return new Vuex.Store({
        state: { 
            area,
            tenant,
            router,
            config
        },
        getters: {
            config(state) { return state.config; }
        },
        modules: modules(area),
        plugins
    })
}


// WEBPACK FOOTER //
// ./src/store/store.js